import * as React from "react";

import { Company } from "../../../../domain/model/company";
import { Project } from "../../../../domain/model/project";

import { TCompanyWithProjectID } from "../../../../domain/repository/company_repository";
import { TPagination } from "../../../type/common";
import Pagination from "../../../common/molecular/pagination/pagination";
import styled from "styled-components";
import ProjectCustomerCard from "../../../common/organism/card/project_customer_card";
import { ConstBreakPoint } from "../../../../config/styles_const/styles_const";
import { User } from "../../../../domain/model/user";
import { Contract } from "../../../../domain/model/contract";

interface IProps {
  projects: Project[];
  companiesWithProjectID: TCompanyWithProjectID[];
  paginationPrams: TPagination;
  user: User | null;
  contractIndex: { [key: string]: Contract | null };
}

export const CustomerEntryMain: React.FC<IProps> = (props) => {
  const {
    projects,
    companiesWithProjectID,
    paginationPrams,
    user,
    contractIndex,
  } = props;

  // projectID: Companyの連想配列を作成し、Projectから連携させる。
  const hashCompany: { [projectID: string]: Company } = {};
  for (const item of companiesWithProjectID) {
    hashCompany[item.projectID] = item.company;
  }

  return (
    <React.Fragment>
      <ProjectCardsWrapper>
        {projects.map((project: Project, index: number) => {
          const company: Company | undefined = hashCompany[project.id];
          const projectId: string = project.id;
          if (!company) {
            return null;
          }
          return (
            <ProjectCardWrapper key={projectId}>
              <ProjectCustomerCard
                company={company}
                project={project}
                user={user}
                contract={contractIndex[projectId]}
              />
            </ProjectCardWrapper>
          );
        })}
      </ProjectCardsWrapper>
      <Pagination paginationPrams={paginationPrams} />
    </React.Fragment>
  );
};

export default CustomerEntryMain;

const ProjectCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`;

const ProjectCardWrapper = styled.div`
    width: 100%
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin:0 15px 30px 0;
        width:calc(33.3333333% - 30px / 3);
        &:nth-child(3n){
            margin-right:0;
        }
    }

`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/entries/customer_entries_main.tsx